import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { AnyAaaaRecord } from 'dns';

@Injectable({
  providedIn: 'root'
})
export class DptmasterService {
  delete(id: number) {
    throw new Error('Method not implemented.');
  }

  constructor(private dataservice: DataService) { }

  getFinancialYear() {
    return this.dataservice.getData('/api/financialyear', true);
  }

  getByFYid(financialyearid: number) {
    return this.dataservice.getData(`/api/financialyear/${financialyearid}`, true);
  }

  updateFinancialYear(data: any) {
    return this.dataservice.post('/api/financialyear', data)
  }

  ///department
  getDepartment() {
    return this.dataservice.getData('/api/department', true);
  }

  getByDepId(departmentId: number) {
    return this.dataservice.getData(`/api/department/department/${departmentId}`, true);
  }

  updateDepartment(data: any) {
    return this.dataservice.post('/api/department', data)
  }

  //go
  getGo(refresh: boolean) {
    return this.dataservice.getData('/api/dbtgo', true);
  }

  getByG0Id(dbtgoId: number) {
    return this.dataservice.getData(`/api/dbtgo/${dbtgoId}`, true);
  }

  updateGo(data: any) {
    return this.dataservice.post('/api/dbtgo', data)
  }

  //scheme
  getScheme(refresh: boolean) {
    return this.dataservice.getData('/api/dbtScheme', true);
  }

  getBySchemeId(dbtgoId: number) {
    return this.dataservice.getData(`/api/dbtScheme/${dbtgoId}`, true);
  }

  updateScheme(data: any) {
    return this.dataservice.post('/api/dbtScheme', data)
  }

  //componennt
  getComponent(refresh: boolean) {
    return this.dataservice.getData('/api/dbtComponent', true);
  }

  getByComponentId(dbtgoId: number) {
    return this.dataservice.getData(`/api/dbtComponent/${dbtgoId}`, true);
  }

  updateComponent(data: any) {
    return this.dataservice.post('/api/dbtComponent', data)
  }

  //DBTGoScheme
  getdbtGoScheme(refresh: boolean) {
    return this.dataservice.getData('/api/dbtGoSchemeComponentMapping', true);
  }

  getBydbtGoSchemeId(dbtGoSchemeId: number) {
    return this.dataservice.getData(`/api/dbtGoSchemeComponentMapping/${dbtGoSchemeId}`, true);
  }

  updatedbtGoSchemeId(data: any) {
    return this.dataservice.post('/api/dbtGoSchemeComponentMapping', data)
  }

  //dbtProduct
  getdbtProduct(refresh: boolean) {
    return this.dataservice.getData('/api/dbtproduct/dbtproducts', true);
  }

  getBydbtProductID(dbtPortalRefNo: number) {
    return this.dataservice.getData(`/api/dbtproduct/dbtproducts/${dbtPortalRefNo}`, true);
  }

  updatedbtProductId(data: any) {
    return this.dataservice.post('/api/dbtproduct/dbtproducts', data)
  }

  //dbtprodctconfig
    getdbtProductConfig(refresh: boolean) {
      return this.dataservice.getData('/api/dbtproductconfig', true);
    }

    getBydbtProductConfigID(id: number) {
      return this.dataservice.getData(`/api/dbtproductconfig/${id}`, true);
    }

    updatedbtProductConfigId(data: any) {
      return this.dataservice.post('/api/dbtproductconfig', data)
    }
    //dbtProduct
    getDbtProductComponentMapping(refresh: boolean) {
      return this.dataservice.getData('/api/DbtProductComponentMapping', true);
    }

    getByDbtProductComponentMappingID(id: number) {
      return this.dataservice.getData('/api/DbtProductComponentMapping/'+id, true);
    }

    updateDbtProductComponentMapping(data: any) {
      return this.dataservice.post('/api/DbtProductComponentMapping', data)
    }
    //dbtProductsubsidymapping
    getdbtproductsubsidymapping(departmentId:any, financialYearId:any, goId:any) {
      return this.dataservice.getData(`/api/dbtproductsubsidymapping/${departmentId}/${financialYearId}/${goId}`, true);
    }

    getBydbtproductsubsidymappingID(id: number) {
      return this.dataservice.getData(`/api/dbtproductsubsidymapping/${id}`, true);
    }

    updatedbtproductsubsidymapping(data: any) {
      return this.dataservice.post('/api/dbtproductsubsidymapping', data)
    }
/////////==

  UpdateMachinaryClassificationby(data: any) {
    return this.dataservice.post('/api/MachinaryClassification', data);
  }

  getmachineClassification() {
    return this.dataservice.getData('/api/MachinaryClassification', true);
  }

  getMachinaryClassificationbyId(refresh: boolean, id: number) {
    return this.dataservice.getData('/api/MachinaryClassification/' + id, refresh);
  }


  MachinaryClassificationTypeLookup(refresh: boolean) {
    return this.dataservice.getData('/api/dbtproduct/machinaryclassification', refresh);
  }


  // machinary category

  getMachinaryCategoryList() {
    return this.dataservice.getData('/api/MachinaryCategory', true);
  }

  getmachinaryCategory(id){
    return this.dataservice.getData('/api/MachinaryCategory/' + id, true);

  }

  updategetmachinaryCategory(data:any){
    return this.dataservice.post('/api/MachinaryCategory', data);
  }


  MachinaryCategoryTypeLookup(refresh: boolean) {
    return this.dataservice.getData('/api/lookup/machinerycategory', refresh);
  }

  MachinaryclassificationLookup(){
    return this.dataservice.getData('/api/dbtproduct/machinaryclassification', true);
  }


  // powerSource

  poersource(){
    return this.dataservice.getData('/api/powersource', true);
  }

  powerSourceLookup(){
    return this.dataservice.getData('/api/dbtproduct/powersource', true);
  }

  getPowerSourcebyId(id){
    return this.dataservice.getData('/api/powersource/' + id, true);
  }

  powerSourcePost(data: any) {
    return this.dataservice.post('/api/powersource', data);
  }


  // dbtproductSpec

  DBTproductSpec(){
    return this.dataservice.getData('/api/dbtproductspec', true);
  }

  getDBTproductspecbyId(id:any){
    return this.dataservice.getData('/api/dbtproductspec/'+id, true);
  }

  UpdateDBTproductspec(data: any){
    return this.dataservice.post('/api/dbtproductspec', data);

  }

  // productcomponentmapping

  departmentlookup(){
    return this.dataservice.getData('/api/lookup/departmentlookup', true);
  }

  getunMappedComponents(data:any){
    return this.dataservice.getData('/api/dbtGoSchemeComponentMapping/unmapcomp/'+data.departmentId+'/'+data.GOId+'/'+data.schemeId, true);
  }
  getComponentAllLookup(departmentId:any){
    return this.dataservice.getData('/api/dbtproduct/alldbtcomponent/'+departmentId, true);
  }

  getComponentlookup(item:any){
    return this.dataservice.getData('/api/dbtproduct/alldbtcomponent/'+item, true);
  }

  getproductlookup(){
    return this.dataservice.getData('/api/dbtproduct/alldbtproduct', true);
  }

  updateproductcomponentmapping(data:any){
    return this.dataservice.post('/api/dbtproductcomponentmapping', data);

  }

  productcomponentmapping(data:any){
    return this.dataservice.getData('/api/dbtproductcomponentmapping/'+data.productid+'/'+data.departmentid, true);
  }

  getAllDept()
  {
    return this.dataservice.getData('/api/lookup/alldepartment',true)
  }

  saveProductSubsidyMap(data:any)
  {
    return this.dataservice.post('/api/dbtproductsubsidymapping',data);
  }

  getProductSubsidyMappingById(data)
  {
    return this.dataservice.getData('/api/dbtproductsubsidymapping/'+data.departmentId+'/'+data.financialYearId+'/'+data.dbtGoId+'/'+data.dbtProductId+'/'+ data.dbtSchemeId+'/'+data.dbtComponentId,true)
  }
  //gramapanchayat

  getProductListService(FinancialYear, DepartmentId, GOId, Scheme, componentId){
    return this.dataservice.getData('/api/dbtproductcomponentmapping/filteredproducts/'+FinancialYear+"/"+DepartmentId+"/"+GOId+"/"+Scheme+"/"+componentId,true)
  }

  getProductListServiceforEdit(FinancialYear, DepartmentId, GOId, Scheme, componentId){
    return this.dataservice.getData('/api/dbtproductcomponentmapping/filteredproductsforedit/'+FinancialYear+"/"+DepartmentId+"/"+GOId+"/"+Scheme+"/"+componentId,true)
  }

  getSubsidyDataByProductId(departmentId, dbtSchemeId, dbtComponentId, productId){
    return this.dataservice.getData('/api/dbtproductsubsidymapping/'+departmentId+"/"+dbtSchemeId+"/"+dbtComponentId+"/"+productId,true);
  }

  saveGramapanchayat(data:any){
    return this.dataservice.post('/api/gramapanchayat',data)
  }
  getGramapanchayat(){
    return this.dataservice.getData('/api/gramapanchayat',true)
  }
  getGramapanchayatById(id: number, refresh: boolean){
    return this.dataservice.getData('/api/gramapanchayat/'+id,refresh)
  }
}
